import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PatientIcon = React.memo(
  ({ width = 47, fill = variables['colors-mc-patient-icon'], viewBox = '0 0 47 47' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect
        id='Rectangle_1421'
        data-name='Rectangle 1421'
        width='47'
        height='47'
        rx='23.5'
        fill={fill}
      />
      <path
        id='person_2_'
        data-name='person (2)'
        d='M12.262,12.262A5.131,5.131,0,1,0,7.131,7.131,5.131,5.131,0,0,0,12.262,12.262Zm3.421-5.131A3.421,3.421,0,1,1,12.262,3.71,3.421,3.421,0,0,1,15.682,7.131Zm6.841,13.682a1.675,1.675,0,0,1-1.71,1.71H3.71A1.675,1.675,0,0,1,2,20.813c0-1.71,1.71-6.841,10.262-6.841S22.523,19.1,22.523,20.813Zm-1.71-.007A4.57,4.57,0,0,0,19.39,17.96c-1.115-1.115-3.214-2.278-7.128-2.278S6.248,16.845,5.133,17.96A4.579,4.579,0,0,0,3.71,20.806Z'
        transform='translate(11.06 11.06)'
        fill='#fff'
      />
    </svg>
  )
);
PatientIcon.displayName = 'PatientIcon';

export default PatientIcon;
